import React, { useState, useEffect } from "react";
import { Images, Link as LinkIcon, X, Plus } from "lucide-react";

export default function AdminCollection() {
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [data, setData] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    image: ""
  });

  useEffect(() => {
    fetchCollection();
  }, []);

  const fetchCollection = async () => {
    const res = await fetch("/api/admin/assets/collection.php");
    const images = await res.json();
    setData(images);
  };

  async function handleSubmit(e) {
  e.preventDefault();

  const url = "/api/admin/assets/add_collection.php"

  const form = new FormData();
  form.append("name", formData.name);

  if (formData.image instanceof File) {
    form.append("image", formData.image);
  }

  if (editingId) {
    form.append("id", editingId);
  }

  try {
    const res = await fetch(url, {
      method: "POST",
      body: form
    });

    if (!res.ok) throw new Error("Erreur sauvegarde");

    fetchCollection();
    resetForm();
  } catch (err) {
    console.error(err);
    alert("Erreur upload");
  }
}

  function resetForm() {
    setShowForm(false);
    setEditingId(null);
    setFormData({
                                name: "",
                                image: ""
    });
  }
  
  async function deleteImage(id) {
    if (!window.confirm("Supprimer cette image ?")) return;

    try {
      await fetch("/api/admin/assets/delete_collection.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id })
      });

      fetchCollection();
    } catch (err) {
      console.error("Erreur suppression image", err);
    }
  }

  return (
      <section>
      <div>
                <div className="container-xl">
                  <div className="bg-white rounded shadow p-4">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h1 className="cat-title h3 fw-bold text-dark d-flex align-items-center gap-2">
                          <Images className="text-primary" />
                          Collection
                        </h1>
                        <p className="text-secondary mb-0">
                          Ajouter, supprimer des images
                        </p>
                        <button
                          onClick={() => {
                            setShowForm(!showForm);
                            if (showForm) {
                              setEditingId(null);
                              setFormData({
                                image: ""
                              });
                            }
                          }}
                          className="btn btn-primary d-flex align-items-center gap-2 mt-2"
                        >
                          <Plus size={20} />
                          Ajouter
                        </button>                        
                      </div>
                    </div>
                  {showForm && (
                    <div className="bg-primary bg-opacity-10 p-4 rounded mt-4 w-100">
                      <h3 className="fw-semibold mb-3">
                        Ajouter une image
                      </h3>
      
                      <form onSubmit={handleSubmit}>
                        <div className="row g-3">
                              <div className="col-12">
                                <label className="form-label fw-medium" htmlFor='img'>Image</label>
                                <input
                                  className="form-control"
                                  type="file"
                                  accept="image/*"
                                  name="image"
                                  onChange={(e)=> setFormData({...formData, image: e.target.files[0]})}
                                />

                                {/* Image existante */}
                                {typeof formData.image === "string" && formData.image && (
                                  <img
                                    src={formData.image}
                                    alt="preview"
                                    style={{ width: "200px", marginTop: "10px" }}
                                  />
                                )}

                                {/* Nouvelle image */}
                                {formData.image instanceof File && (
                                  <img
                                    src={URL.createObjectURL(formData.image)}
                                    alt="preview"
                                    style={{ width: "200px", marginTop: "10px" }}
                                  />
                                )}
                            </div>
      
                            <div className="d-flex gap-2 mt-4">
                              <button type="submit" className="btn btn-primary">
                                "Enregistrer"
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setShowForm(false);
                                  setEditingId(null);
                                  setFormData({
                                    name: "",
                                    image: ""
                                  });
                                }}
                                className="btn btn-secondary"
                              >
                                Annuler
                              </button>
                            </div>
                            </div>
                          </form>
                        </div>
                      )}
                      <div className="row g-3 pt-4">
                        {data.map((image, i) => {
      
                          return (
                            <div className="col-md-4 mb-3" key={image.id}>
                              <div className="card border-dark bg-white rounded shadow p-3 h-100">
                                <div className="border-bottom pb-2 mb-2">
                                  <h2 className="h4 fw-bold">{image.name}</h2>
                                  <img
                                    src={image.image}
                                    alt="preview"
                                    style={{ width: "100%", marginTop: "10px" }}
                                  />
                                </div>
                                          <div className="d-flex gap-1">
                                            <button
                                              onClick={() => deleteImage(image.id)}
                                              className="btn btn-sm btn-outline-dark"
                                              title="Supprimer"
                                            >
                                              <X size={18} />
                                            </button>
                                          </div>
                                  </div>
                            </div>
                          );
                        })}
                      </div>
                  </div>
                </div>
              </div>
    </section>
  );
}